import React, {useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
import { getWithExpiry, setWithExpiry } from '../common';
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import configVars from "../config";

const CourseProgress = ( props ) => {

	const [courseProgress, setCourseProgress] = useState(0);
	const [cookies] = useCookies(["sustainyou_user_jwt"]);
	const { board_id } = useParams();
	const [translation] = useTranslation("translations");

	const progressPersentage = ( completed, total ) => {

		if ( !completed || !total ) return;

		const p = (completed/total)*100;
		const pr = p.toFixed();

		return pr;

	}

	useEffect(() => {

		const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

		let progressData;

		if ( props.progress && Object.keys( props.progress ).length  > 0 ) {
			progressData = props.progress;
		} else if ( props?.courseID ) {
			progressData = getWithExpiry(`course_progress_${props?.courseID}_${jwtDecoded.id}`);
		} else {
			progressData = getWithExpiry(`course_progress_${board_id}_${jwtDecoded.id}`);
		}

		if ( progressData ) {

			const progress = progressPersentage( progressData.completed, progressData.total );

			if ( progress ) setCourseProgress( progress );

		} else {

			(async () => {

				if ( ! props.topic ) {

					let cachedProgress;
					
					if ( props?.courseID ) {
						cachedProgress = localStorage.getItem( `course_progress_${props?.courseID}_${jwtDecoded.id}` );
					}

					if ( board_id ) {
						cachedProgress = localStorage.getItem( `course_progress_${board_id}_${jwtDecoded.id}` );
					}

					if ( cachedProgress ) {
						const progress = progressPersentage( cachedProgress.completed, cachedProgress.total );

						if ( progress ) setCourseProgress( progress );

						return;
					}
				}
				
				const response = await fetch(`${configVars.lmsApiUrl}sustainchangelms/v1/getcourseprogress/?topicid=${props.topic}&userid=${jwtDecoded.id}`);
				
				const courseResponse = await response.json();
	
				if ( courseResponse ) {

					if ( courseResponse.success === true ) {
						
						if ( props?.courseID ) {
							setWithExpiry(`course_progress_${props?.courseID}_${jwtDecoded.id}`, courseResponse.data );
						}
						if ( board_id ) {
							setWithExpiry(`course_progress_${board_id}_${jwtDecoded.id}`, courseResponse.data );
						}

						const progress = progressPersentage( courseResponse.data.completed, courseResponse.data.total );

						if ( progress ) setCourseProgress( progress );
					}
	
				}
	
			})()

		}

	}, [props, cookies, board_id]);
  
	return (
		<div className="course-progress-wrap position-absolute d-none d-lg-block">
			<div className="course-progress rounded-circle position-absolute">
				<svg className="course-progress-circle" width="200px" height="200px" xmlns="http://www.w3.org/2000/svg">
					<circle className="course-progress-circle-back" cx="80" cy="80" r="74"></circle>
					<circle className="course-progress-circle-prog" cx="80" cy="80" r="74" style={{strokeDasharray:` ${courseProgress * 4.64}, 999`}}></circle>
				</svg>
				<div className="course-progress-text position-absolute top-0 left-0 d-flex flex-column justify-content-center align-items-center text-white w-100 h-100" data-progress="0">
					<span className="h4">{courseProgress}%</span>
					<span>{translation("completed")}</span>
				</div>
			</div>
		</div>
	);
};

export default CourseProgress;
